import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import { useTranslation } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO } from "../../../utils/const/estilos-const";
import { COLOR_AZUL_MAIN, } from "../../../utils/const/colors-const";
import { crearUsuarioPlataforma, obtenerUsuarioEmpresaPlataforma, recoverPasswordUsuarioPlataforma } from "../../../api/api-usuario-web";
import ModalFormCrearSubUsuario from "../../../components/form-crear-sub-usuario";
import ModalFormRecoverPassword from "../../../components/form-recover-password";
import { STRING_COLOR_PRIMARIO } from "../../../utils/const/string-const";
ModuleRegistry.registerModules([AllCommunityModule]);


export default function UsuarioEmpresa() {
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [rowData, setRowData] = useState([]);
    const [idEmpresaPlataforma, setIdEmpresaPlataforma] = useState(0);
    const [showModalCrearSubUsuario, setShowModalCrearSubUsuario] = useState(false);
    const [showModalRecoverPassword, setShowModalRecoverPassword] = useState(false);
    const [formData, setFormData] = useState({});
    const [primaryColor, setPrimaryColor] = useState(COLOR_AZUL_MAIN);

    const columnDefs = [
        {
            field: "acciones", headerName: t("column_actions"), width: 250,
            cellRenderer: (params) => {
                // console.log('cellRenderer');
                // console.log(params);
                return (
                    <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                        <button
                            onClick={() => handleRecoverPassword(params.data)}
                            style={{
                                backgroundColor: "#1E90FF",
                                color: "white",
                                border: "none",
                                padding: "5px 10px",
                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                        >
                            {t("label_recover_password")}
                        </button>
                    </div>
                );
            }
        },
        { field: "usuario", headerName: t("column_user"), filter: true, },
        { field: "fechamodificacion", headerName: t("column_date_modify"), filter: true },
        { field: "essubcuenta", headerName: t("column_es_sub_cuenta"), filter: true, },
    ];

    useEffect(() => {
        const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
        if (mainColor !== null) {
            setPrimaryColor(mainColor);
        }
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            if (data.params !== undefined && data.params !== null) {
                setIdEmpresaPlataforma(data.params.id);
            }
            let objEnviar = {};
            objEnviar.idEmpresaPlataforma = data.params.id;
            const response = await obtenerUsuarioEmpresaPlataforma(objEnviar, t);
            // console.log('response');
            // console.log(response);
            if (response.error === false) {
                setRowData(response.body);
            }
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const handleRecoverPassword = (data) => {
        try {
            console.log('handleRecoverPassword');
            console.log(data);
            setFormData({
                ...formData,
                nombreUsuario: data.usuario,
                password: "",
                confirmPassword: "",
            });
            setShowModalRecoverPassword(true);
        } catch (err) {
            console.log('handleRecoverPassword err');
            console.log(err);
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const handleNuevoClick = () => {
        try {
            // console.log('handleNuevoClick');
            setFormData({
                ...formData,
                nombreUsuario: "",
                password: "",
                confirmPassword: "",
            });
            setShowModalCrearSubUsuario(true);
        } catch (err) {
            console.log('handleNuevoClick err');
            console.log(err);
        }
    };

    const reset = () => {
        setCargandoPage(true);
        iniciar();
    };

    const onConfirmModal = async (formData) => {
        try {
            // console.log('onConfirmModal');
            // console.log(formData);
            formData.idEmpresaPlataforma = idEmpresaPlataforma;
            setShowModalCrearSubUsuario(false);
            const resp = await crearUsuarioPlataforma(formData);
            // console.log('resp');
            // console.log(resp);
            if (resp.error === false) {
                alert(t("alert_successfully_proccess"));
                reset();
            }
            if (resp.error === true) {
                alert(resp.message);
            }
        } catch (err) {
            console.log('onConfirmModal err');
            console.log(err);
        }
    };

    const onConfirmRecoverPassword = async (formData) => {
        try {
            // console.log('onConfirmRecoverPassword');
            // console.log(formData);
            formData.idEmpresaPlataforma = idEmpresaPlataforma;
            setShowModalRecoverPassword(false);
            // return;
            const resp = await recoverPasswordUsuarioPlataforma(formData);
            // console.log('resp');
            // console.log(resp);
            if (resp.error === false) {
                alert(t("alert_successfully_proccess"));
                reset();
            }
            if (resp.error === true) {
                alert(resp.message);
            }
        } catch (err) {
            console.log('onConfirmModal err');
            console.log(err);
        }
    };

    const render = () => {
        // console.log('render correo');
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            return (
                <div className="p-4">
                    <div className="flex justify-between">
                        <label
                            style={{
                                // paddingLeft: 10,
                                fontWeight: 'bold',
                            }}
                        >
                            {t("title_users_companies")}
                        </label>
                        <div className="flex justify-center">
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_NUEVO}
                                onClick={() => { handleNuevoClick(); }}
                                style={{

                                }}
                            >
                                {t("label_new")}
                            </button>
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={(handleAtrasClick)}
                            >
                                {t("label_back")}
                            </button>
                            {/* <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={handleAtrasClick}
                              >
                                <Settings />
                              </button> */}
                        </div>
                    </div>
                    <div className="flex justify-between">
                        <div className="">
                            <label className="block">&nbsp;</label>
                            <button
                                type="button"
                                className={`bg-[#000D39] text-white font-semibold py-2 px-4 rounded hover:bg-[#0F3457] transition`}
                                onClick={() => reset()}
                            >
                                {t("label_update")}
                            </button>
                        </div>
                    </div>
                    <div
                        className="ag-theme-alpine pt-4"
                        style={{
                            height: "512px",
                            width: "100%",
                            "--ag-header-background-color": `${primaryColor}`,
                        }}
                    >
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            pagination={true}
                            rowHeight={50}
                        />
                    </div>
                    <ModalFormCrearSubUsuario
                        isOpen={showModalCrearSubUsuario}
                        formData={formData}
                        setFormData={setFormData}
                        onCancel={() => { setShowModalCrearSubUsuario(false); }}
                        onConfirm={onConfirmModal}
                    />
                    <ModalFormRecoverPassword
                        isOpen={showModalRecoverPassword}
                        formData={formData}
                        setFormData={setFormData}
                        onCancel={() => { setShowModalRecoverPassword(false); }}
                        onConfirm={onConfirmRecoverPassword}
                    />
                </div >
            );
        } catch (err) {
            console.log('Empresa render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
}
